module.exports = function() {
  return new Worker(__webpack_public_path__ + "bdd1253846aa7e040685.worker.js");
};